import './parcelSynthesisTable.style.scss';
import './cultureListTable.style.scss';
import './table.style.scss';
import { v1 } from 'uuid';
import { toLowerCaseWithFirstLetterUpper } from '../Generics/utilsFunctions';
import { useTranslation } from 'react-i18next';

const CultureListTable = ({ truncatedCultures, messageDuplicate, isOrganic }) => {
  const { t } = useTranslation();

  let headers = [
    { headerText: t('common.name') },
    { headerText: t('simulation.result.pdf.cultureList.salePrice'), unit: '(€/t)' },
    { headerText: t('common.yield'), unit: '(t/ha)' },
    { headerText: t('simulation.common.cost'), unit: '(€/ha)' },
    { headerText: t('simulation.result.pdf.cultureList.extraCost'), unit: '(€/ha)' },
    { headerText: t('common.ift') },
    { headerText: t('simulation.result.pdf.cultureList.presenceDuration'), unit: '(an)' },
    { headerText: t('common.prohibitionDuration') },
    { headerText: t('common.constraints') },
  ];

  return (
    <article className="pdf-page">
      <div className="culture_list_wrapper">
        <h6 className="title_h6">
          {truncatedCultures.length > 0 && messageDuplicate !== ''
            ? `${t(isOrganic ? 'simulation.result.pdf.cultureList.titleBio' : 'simulation.result.pdf.cultureList.titleConventional')} ${messageDuplicate}`
            : t(
                isOrganic
                  ? 'simulation.result.pdf.cultureList.titleBio'
                  : 'simulation.result.pdf.cultureList.titleConventional',
              )}
        </h6>
        <table
          className="table table_full_page_culture"
          style={{ height: truncatedCultures.length <= 5 ? 'auto' : '' }}
        >
          <thead className="table_head">
            <tr className="table_tr">
              {headers.map((header, i) => (
                <th
                  key={i}
                  scope="col"
                  className="column_name_culture"
                  style={{ width: header.headerText === 'Nom' ? '150px' : 'auto' }}
                >
                  <div className="cell_flex_column">
                    <div>{header.headerText}</div>
                    {header?.unit && <div>{header.unit}</div>}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {truncatedCultures?.map((culture, index) => (
              <tr
                className="table_tr"
                key={v1()}
                style={{ backgroundColor: index % 2 !== 0 ? '#F8E4CC' : 'white' }}
              >
                <td className="value_table_culture cell_name">
                  <div
                    className="inline_icon_cell name_and_color_wrapper"
                    style={{ minHeight: truncatedCultures.length <= 5 ? '42px' : 'auto' }}
                  >
                    <span className="text-left">
                      {toLowerCaseWithFirstLetterUpper(culture?.name)}
                    </span>
                    <div className="icons">
                      {culture?.color && (
                        <div className="color" style={{ backgroundColor: culture.color }}></div>
                      )}
                    </div>
                  </div>
                </td>
                <td className="value_table_culture not_name_cell">
                  {culture?.economicAttributeCollection?.price?.currentEconomicValue}
                </td>
                <td className="value_table_culture not_name_cell">{culture?.yield}</td>
                <td className="value_table_culture not_name_cell">
                  {culture?.economicAttributeCollection?.inputCost?.currentEconomicValue}
                </td>
                <td className="value_table_culture not_name_cell">{culture?.extraCost ?? 0}</td>
                <td className="value_table_culture not_name_cell">{culture?.ift}</td>
                <td className="value_table_culture not_name_cell">{culture?.presenceDuration}</td>
                <td className="value_table_culture not_name_cell">
                  {culture?.prohibitionDuration}
                </td>
                {culture?.minMax !== 'undefined' ? (
                  <td className="value_table_culture not_name_cell"></td>
                ) : (
                  <td className="value_table_culture align_left not_name_cell">
                    <div className="flex-column">
                      <span>
                        {t('common.min')} :{' '}
                        {culture.minMax.min + ' ' + culture.minMax.type}
                      </span>
                      <span>
                        {t('common.max')} :{' '}
                        {culture.minMax.max + ' ' + culture.minMax.type}
                      </span>
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </article>
  );
};

export default CultureListTable;
